var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { workerFactory } from "@modules/app";
import { TrainingOrchestratorModule } from "@modules/training";
import { trainingUserMistakeService } from "@modules/training/services/TrainingUserMistakeService";
export class ScriptTraining {
    static getStageErrors() {
        return trainingUserMistakeService.getStageErrors();
    }
    static addStageError(stageId, text, errorType) {
        const module = workerFactory.getModule(TrainingOrchestratorModule);
        if (module === undefined) {
            console.warn("[scripting] TrainingOrchestratorModule not found");
            return;
        }
        module.addStageError(stageId, text, errorType);
    }
    static getTrainingObjectState(uidOrTrainingObjectId) {
        const module = workerFactory.getModule(TrainingOrchestratorModule);
        if (module === undefined) {
            console.warn("[scripting] TrainingOrchestratorModule not found");
            return undefined;
        }
        return module.getTrainingObjectState(uidOrTrainingObjectId);
    }
    static setTrainingObjectState(uidOrTrainingObjectId, stateName) {
        return __awaiter(this, void 0, void 0, function* () {
            const module = workerFactory.getModule(TrainingOrchestratorModule);
            if (module === undefined) {
                console.warn("[scripting] TrainingOrchestratorModule not found");
                return;
            }
            yield module.setTrainingObjectState(uidOrTrainingObjectId, stateName);
        });
    }
}
